module.exports = __webpack_public_path__ + "ad61abb92326621504f02111abaab4d8.png";